import { Grid, TextField, Box, Stack, Chip, Button } from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { HelperTextComponent } from "../common/HelperTextComponent";

export const AddCondition = (props: any) => {
  const { errors, register, watch, setValue, isEdit, studyData } = props;
  const [conditions, setConditions] = useState<any>(
    isEdit ? studyData?.primary_disease_or_conditions : []
  );
  const [conditionName, setConditionName] = useState<string>("");
  const handleAddCondition = () => {
    setConditions([...conditions, conditionName?.trim()]);
    setConditionName("");
  };

  const handleDeleteChip = (id: number) => {
    setConditions(
      conditions.filter((item: any, index: number) => index !== id)
    );
  };
  const watchConditions = watch("conditions");

  useEffect(() => {
    setValue("conditions", conditions);
  }, [watchConditions, register]);
  return (
    <Grid container columnSpacing={3} className="mt2">
      <Grid item xs sx={{ maxWidth: "calc(100% - 146px) !important" }}>
        <TextField
          fullWidth
          label="Primary Disease or Condition"
          type="text"
          value={conditionName}
          variant="standard"
          onChange={(e) => {
            setConditionName(e.target.value);
          }}
          inputProps={{ maxLength: 150 }}
          required
          error={
            conditions.length == 0 && errors[`conditions`] 
          }
          helperText={
            (conditionName?.length === 150 && (
              <HelperTextComponent mlength="150" />
            )) ||
            (conditions.length == 0 &&
              errors[`conditions`]?.message)
          }
          id="add-condition"
        />
        <input
          type="hidden"
          value={conditions}
          {...register("conditions", { value: conditions })}
        />
        <Stack
          direction="row"
          rowGap={1}
          columnGap={1}
          mt={1}
          mb={2}
          className="flexWrap"
        >
          {conditions.length > 0 &&
            conditions?.map((item: any, index: any) => {
              return (
                <Chip
                  size="small"
                  label={item}
                  variant="outlined"
                  color="primary"
                  onDelete={() => handleDeleteChip(index)}
                  key={index}
                  id={`condition-${index + 1}`}
                />
              );
            })}
        </Stack>
      </Grid>
      <Grid item>
        <Box className="mt1">
          <Button
            variant="contained"
            endIcon={<AddIcon />}
            onClick={() => handleAddCondition()}
            disabled={conditionName?.trim()?.length == 0}
            id="add_condition_button"
          >
            Add NEW
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};
